import { formsApi } from "../../../lib/api";
import { useState } from "react";

export default function NewsNewsletter() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      const body = new URLSearchParams({ email });
      await formsApi.newsletter(email);
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-cl-tint">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="bg-cl-dark rounded-3xl p-10 md:p-14 flex flex-col lg:flex-row items-center justify-between gap-8 cartoon-card">
          {/* Left */}
          <div className="max-w-md text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-cl-lime/20 border border-cl-lime/30 rounded-full px-3 py-1 mb-4">
              <i className="ri-mail-send-line text-cl-lime text-xs"></i>
              <span className="text-cl-lime text-xs font-black uppercase tracking-widest">Weekly digest</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-white leading-tight mb-3">
              Waste tips &amp; news.<br />
              <span className="text-cl-lime">Straight to your inbox.</span>
            </h2>
            <p className="text-white/60 text-sm font-semibold leading-relaxed">
              Seasonal clearance guides, eco news, and exclusive offers — no spam, unsubscribe any time.
            </p>
          </div>

          {/* Right */}
          <div className="w-full lg:w-auto lg:min-w-[380px]">
            {submitted ? (
              <div className="bg-cl-lime rounded-2xl p-6 flex items-center gap-4 cartoon-shadow-sm">
                <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-cl-dark flex-shrink-0">
                  <i className="ri-check-line text-cl-lime text-xl font-black"></i>
                </span>
                <div>
                  <p className="text-cl-dark font-black text-base">You&apos;re in!</p>
                  <p className="text-cl-dark/70 text-sm font-semibold">First issue lands next Monday. See you there.</p>
                </div>
              </div>
            ) : (
              <form
                id="news-newsletter-form"
               
                onSubmit={handleSubmit}
                className="flex flex-col sm:flex-row gap-3"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 bg-white/10 border-2 border-white/20 rounded-2xl px-4 py-3.5 text-sm text-white placeholder-white/40 focus:outline-none focus:border-cl-lime transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-cl-lime text-cl-dark font-black text-sm px-7 py-3.5 rounded-2xl cartoon-btn whitespace-nowrap disabled:opacity-60 cursor-pointer"
                >
                  {submitting ? "Subscribing..." : "Subscribe Free"}
                </button>
              </form>
            )}
            {error && <p className="text-red-400 text-xs font-semibold mt-2">{error}</p>}
            {!submitted && (
              <p className="text-white/30 text-xs font-semibold mt-3 text-center sm:text-left">
                Joining 4,800+ readers. Unsubscribe any time.
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
